import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { unwrappedPlayerIdMappingAtom } from '@/atoms/queries/players';
import { unwrappedUserNavOverridesAtom } from '@/atoms/queries/user';
import { classicEntityDashboardUrl } from '@/utils/classicLinks';

/**
 * Resolves the player dashboard URL for the user's chosen experience, so consumers can
 * pass it into the preview panel and the preview itself stays ignorant of classic vs new.
 * Returns undefined in classic mode when the IQ id isn't mapped yet — consumers render the
 * dashboard action as non-interactive in that case.
 */
export const usePlayerDashboardHref = (playerId: string | number | null): string | undefined => {
  const {
    i18n: { language },
  } = useTranslation();
  const isClassicPlayerXp = useAtomValue(unwrappedUserNavOverridesAtom).player;
  const playersMapping = useAtomValue(unwrappedPlayerIdMappingAtom);

  if (!playerId) return undefined;

  if (isClassicPlayerXp) return classicEntityDashboardUrl('player', playersMapping[Number(playerId)]);

  return `/${language}/player/${playerId}/dashboard`;
};
